// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__21RW0","label":"Labeled_label__xS07J","divider":"Labeled_divider__3x4Db"};